import { render, staticRenderFns } from "./RecentActivityCardPhotoSnippet.vue?vue&type=template&id=bfd68b18&scoped=true&"
import script from "./RecentActivityCardPhotoSnippet.vue?vue&type=script&lang=js&"
export * from "./RecentActivityCardPhotoSnippet.vue?vue&type=script&lang=js&"
import style0 from "./RecentActivityCardPhotoSnippet.vue?vue&type=style&index=0&id=bfd68b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd68b18",
  null
  
)

export default component.exports